module.exports = __webpack_public_path__ + "img/Icon.f19b6e70.svg";